import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import "swiper/css";
import testimonialData from "../data/testimonialData";
import axios from "axios";

export default function TestimonialSection() {
  const [testimonies, setTestimonies] = useState([]);
  useEffect(() => {
    // if (testimonies?.length < 1) {
    //   setTestimonies(testimonialData);
    // }
    axios
      .get("/testimonial")
      .then(({ data }) => {
        if (data) {
          
          setTestimonies(data);
        } else {
          setTestimonies(testimonialData);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const testimonialElements = testimonies.map((testimony) => (
    <SwiperSlide key={testimony._id}>
      <div className="testi_content">
        <div className="testi_image">
          <img src={testimony.imageUrl ? testimony.imageUrl :`images/default.jpg`} alt="Testimonial" />
        </div>

        <div className="aside">
          <h4>{testimony.username}</h4>
          <p>{testimony.testimony}</p>
        </div>
      </div>
    </SwiperSlide>
  ));
  return (
    <div className="testi_section">
      <div className="testi_container">
        <div className="testi_header">
          <h2 style={{
            textTransform: "uppercase"
          }}>Testimonials</h2>
          <p>See what people are saying...</p>
        </div>

        <Swiper
          // install Swiper modules
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          spaceBetween={50}
          autoplay={true}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
          onSwiper={(swiper) => console.log(swiper)}
          onSlideChange={() => console.log("slide change")}
        >
          {testimonialElements}
        </Swiper>
      </div>
    </div>
  );
}
